export default __webpack_public_path__ + "static/media/f.a5800b8a.png";